export default __webpack_public_path__ + "static/media/ship-3.186a3cd8.png";